import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import FormField from "./FormField";

function FormAutocomplete(props) {
  const [stateValue, setValue] = useState(null);
  const labels = useMemo(() => {
    const labels = {};
    props.options.forEach((option) => {
      labels[option.value] = option.label;
    });
    return labels;
  }, [props.options]);
  return (
    <FormField
      {...props}
      Field={Autocomplete}
      fieldProps={({ value, onChange }) => {
        let val;

        val =
          (props.multiple
            ? stateValue
            : typeof value == "object"
              ? value
              : value == null
                ? null
                : { value, label: labels[value] }) ??
          (value
            ? JSON.parse(value).map((id) => ({
                value: id,
                label: labels[id],
              }))
            : props.multiple
              ? []
              : null);

        return {
          options: props.options,
          onChange: (e, value) => {
            if (props.multiple) {
              setValue(value);
              let parsed = JSON.stringify(value.map((obj) => obj.value));
              onChange({ target: { value: parsed } }, parsed);
            } else {
              onChange({ target: { value: value?.value } }, value?.value);
            }

            // setValue(value);
            // onChange({ target: { value: value?.value } }, value?.value);
          },
          onInputChange: (e, value) => {
            if (e?.type === "change" && props.freeSolo) {
              onChange({ target: { value: value } }, value);
              setValue({ value, label: value });
            }
          },
          ChipProps: { color: "primary" },
          size: "small",
          isOptionEqualToValue: (option, value) => option.value === value.value,
          getOptionLabel: props.getOptionLabel ?? ((option) => option.label ?? "????"),
          renderInput: (params) => <TextField {...params} variant={"standard"} />,
          value: val,
          nullable: props.nullable,
          freeSolo: !props.multiple && props.freeSolo,
          multiple: props.multiple,
        };
      }}
    />
  );
}

FormAutocomplete.defaultProps = {
  nullable: false,
  freeSolo: false,
  multiple: false,
  options: [],
};

FormAutocomplete.propTypes = {
  name: PropTypes.string.isRequired, // FormField props
  tKey: PropTypes.string, // FormField props
  tDefault: PropTypes.string, // FormField props
  permissionKey: PropTypes.string, // FormField props
  gridSizes: PropTypes.object, // FormField props
  rules: PropTypes.object, // FormField props
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]), // FormField props

  options: PropTypes.array,
  freeSolo: PropTypes.bool,
  multiple: PropTypes.bool,
};

export default FormAutocomplete;
